// src/state/modules/company.js
export const state = {
    currentCompany: null,
    companies: [],
    status: { loading: false, error: null },
}

export const actions = {
    setCompanies({ commit }, companies) {
        commit('setCompanies', companies || [])
        localStorage.setItem('companies', JSON.stringify(companies || []))
    },

    switchCompany({ commit, state }, companyUuid) {
        const target = state.companies.find(c => c.CompanyUUID === companyUuid)
        if (target) {
            commit('setCompany', target)
            localStorage.setItem('company', companyUuid)
        }
    },

    clearCompanyData({ commit }) {
        commit('clearCompanies')
        commit('clearCompany')
        localStorage.removeItem('companies')
        localStorage.removeItem('company')
    },
}

export const mutations = {
    setCompanies(state, companies) { state.companies = companies || [] },
    setCompany(state, company)     { state.currentCompany = company || null },
    clearCompanies(state)          { state.companies = [] },
    clearCompany(state)            { state.currentCompany = null },
}
